import { CartonContentLineDto } from './carton-content-line.dto';
import { ProductSummary } from './product-summary';

export class CartonContentLine {
    readonly product: ProductSummary;
    readonly quantity: number;

    constructor(dto: CartonContentLineDto) {
        this.product = new ProductSummary(dto.product);
        this.quantity = dto.quantity;
    }
}
